import S from "./Spinner.module.scss";

// The site's one and only spinner. Every loading indicator in the app renders
// through here so size and color can never drift apart between screens again.
// Change these two constants to restyle every spinner in the app.
export const SPINNER_SIZE = 60;
export const SPINNER_COLOR = "#EB0A1E";

// Inline spinner, for loading states scoped to a region of an already-rendered
// page (a carousel, a modal body, a video thumbnail). It centers itself in
// whatever box it is dropped into. For a page-level load use DelayedSpinner
// instead, which pins itself to a fixed spot in the viewport.
// <output> rather than a div with role="status": it carries that role
// implicitly and is the element assistive tech support most consistently.
// Queries for role "status" keep working unchanged.
const Spinner = ({ size = SPINNER_SIZE, color = SPINNER_COLOR, className }) => (
  <output
    className={className}
    style={{
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
    }}
    aria-live="polite"
    aria-busy="true"
  >
    <span
      className={S.spinner}
      style={{
        width: size,
        height: size,
        borderColor: `${color} ${color} transparent`,
      }}
    />
  </output>
);

export default Spinner;
